import React from "react";
import GlobalState from "../../useGlobalState";
import sanitizeHtml from "sanitize-html";
const sanitizeConf = {
  allowedTags: [...sanitizeHtml.defaults.allowedTags, ...["img","svg"]],
  allowedAttributes: {
    "*": ["*"],
  },
};

const AttributesTabContent = () => {
  const { state, dispatch } = GlobalState.useContainer();

  const selectedNodeId = state.selectedNode?.id;

  const customHtml =
    (state.attributes && state.attributes[selectedNodeId]?.customHtml) || "";

  const handleChange = (evt) => {
    dispatch({
      type: "REPLACE_ATTRIBUTES_FOR_SELECTED_NODE",
      payload: {
        customHtml: evt.target.value,
      },
    });
  };

  const sanitize = () => {
    dispatch({
      type: "REPLACE_ATTRIBUTES_FOR_SELECTED_NODE",
      payload: {
        customHtml: customHtml,
      },
    });
  };

  return (
    <div className="p-4">
      <textarea
        className="resize border rounded focus:outline-none focus:shadow-outline w-1/2 mx-auto"
        placeholder="Custom html goes here..."
        value={customHtml}
        onChange={handleChange}
        onBlur={sanitize}
      />
    </div>
  );
};

export default AttributesTabContent;
